import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-app-skeleton-loader-ui',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './app-skeleton-loader-ui.component.html',
  styleUrl: './app-skeleton-loader-ui.component.css',
})
export class AppSkeletonLoaderUiComponent {
  appearance: 'circle' | 'line' | 'custom-content' | '' = 'line';
  theme: any = { 'height': '42px', 'width': '100%', 'border-radius': '0.375rem', 'margin-bottom': '0' };

}
